import { FC, useEffect, useRef, useState } from 'react'

import { Episode } from 'models'
import { Episode as EpisodeContainer } from './styled'

type Props = {
  episode: Episode
  onClick: () => void
}

export const EpisodeTile: FC<Props> = ({ episode, onClick }) => {
  const video = useRef<HTMLVideoElement>(null)
  const [isHover, setHover] = useState(false)
  const [isPlaying, setPlaying] = useState(false)

  useEffect(() => {
    if (isHover && !isPlaying) {
      void video.current?.play()
      setPlaying(true)
    } else if (!isHover && isPlaying) {
      video.current?.pause()
      video.current?.load()
      setPlaying(false)
    }
  }, [isHover, isPlaying])

  return (
    <EpisodeContainer
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <button onClick={onClick}>
        <figure>
          <video
            ref={video}
            loop
            preload="auto"
            muted
            poster={episode.episode_cover}
            playsInline
          >
            <source src={episode.episode_loop} />
          </video>

          <figcaption>{episode.episode_title}</figcaption>
        </figure>
      </button>
    </EpisodeContainer>
  )
}
